var _defs, _g, _g2, _g3, _g4, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMrskexcited(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    "data-name": "Layer 4",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 461.12 407.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #d6d6d6;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-4 {\n        stroke-width: 3px;\n      }\n\n      .cls-4, .cls-5 {\n        fill: #e6e6e6;\n        stroke: #e6e6e6;\n      }\n\n      .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10 {\n        stroke-width: 3px;\n      }\n\n      .cls-6 {\n        fill: #848484;\n        stroke: #848484;\n      }\n\n      .cls-7 {\n        fill: #b5b5b6;\n        stroke: #b5b5b6;\n      }\n\n      .cls-8 {\n        fill: #9c9c9c;\n        stroke: #9c9c9c;\n      }\n\n      .cls-2 {\n        fill: #9b9a9a;\n      }\n\n      .cls-9 {\n        fill: #5f5f5f;\n      }\n\n      .cls-9, .cls-10 {\n        stroke: #5e5f5f;\n      }\n\n      .cls-3 {\n        fill: #9b9b9b;\n      }\n\n      .cls-10 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Colour_Mirror",
    "data-name": "Colour Mirror"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M181.88,247.11l-47.92,24.19s5.37,25.98,5.37,29.71-9.7,24.34-9.7,24.34l2.99,10.15-2.09,11.79-9.41,7.61v12.39l-4.03,11.05v17.62l161.76,9.27-23.59-84.19-36.13-53.72,3.39-35.76h-14.81l-26.16,8.61.34,6.95h-.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "224.6 225.99 221.83 264.44 255.26 321.04 288.69 264.44 286.5 225.71 286.5 186.59 212.57 173.76 210.14 200.66 224.6 225.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M328.64,247.11l47.92,24.19s-5.37,25.98-5.37,29.71,9.7,24.34,9.7,24.34l-2.99,10.15,2.09,11.79,9.41,7.61v12.39l4.03,11.05v17.62l-161.76,9.27,23.59-84.19,36.13-53.72-2.69-37.03,10.38.54,29.9,9.33-.34,6.95h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M259.73,275.06s12.97-2.6,16.85-2.6c0,0,2.53,4.98.45,13.58,0,0,11.67-19.51,11.67-21.6s-20.75,0-20.75,0l-8.21,10.62h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M250.79,275.06s-12.97-2.6-16.85-2.6c0,0-2.53,4.98-.45,13.58,0,0-11.67-19.51-11.67-21.6s20.75,0,20.75,0l8.21,10.62h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 145.41,
    y: 119.02,
    width: 111.44,
    height: 44.2,
    transform: "translate(-30.41 223.31) rotate(-54.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M272.5,109.11l-43.33-21.15-76.19,19.47h0l6.67,78.35,34.23,33.96,12.43-21.53,24.26,6.6,29.99-5.59,14.49-20.39-1.97-21.42,15.41.18,3.58-5.42-19.56-43.05h0ZM196.74,154.54l-2.51,13.35-14.8,11.01-9.05-3.27,1.94-14.27,10.23-8.63,12.43-1.94,1.76,3.74h0ZM211.86,133.26l-4.11-.43-2.26-12.37,4.78-12.5,12.83-6.52,6.06,7.47-5.53,17.6-11.78,6.76h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M198.69,151.79c-1.41-.48-3.71-.99-3.71-.99l1.76,3.74-2.51,13.35-14.8,11.01-9.05-3.27,1.94-14.27,9.93-9.66,12.73-.9-18.22-5.6-14.47,18.14s6.71,21.92,12.29,22.36c5.59.43,24.61-13.77,26.08-15.84s-.56-17.59-1.97-18.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M209.91,136.01c-.92-1.18-2.16-3.18-2.16-3.18l4.11.43,11.78-6.76,5.53-17.6-6.06-7.47-12.83,6.52-5.86,12.56,3.34,12.31-11.28-15.36,12.37-19.63s22.91-.88,25.16,4.25c2.25,5.13-4.91,27.77-6.38,29.84s-16.8,5.26-17.71,4.08h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "183.07 161.57 184.23 165.19 187.55 165.29 189.43 161.3 186.63 158.91 183.07 161.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "212.31 119.88 213.47 123.5 216.79 123.6 218.67 119.61 215.87 117.22 212.31 119.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M234.29,156.74c-.72,1.01-1.5,5.38-2.46,6.72s-4.82,3.52-5.54,4.53,1.18,3.74,2.35,3.63c1.17-.11,5.33-3.01,7.19-5.32,1.57-2.52,2.94-7.4,2.66-8.54s-3.48-2.04-4.2-1.03h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "254.01 146 239.83 169.15 222.63 190.15 245.1 190.06 255.52 180.82 255.68 180.94 255.85 180.53 256.18 180.23 256.01 180.12 261.32 167.24 254.01 146"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M231.38,179.02s1.16,7.89,4.5,8.88,11.03,3.23,11.03,3.23l-24.73-.54,9.2-11.56h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M246.37,157.91s7.83-1.5,9.86,1.33,6.68,9.36,6.68,9.36l-8.65-23.17-7.89,12.49h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M207.52,196.9s6.05,26.3,6.02,31.56c-.04,7.59-2.73,13.5-1.75,16.11,2.33,6.21,14.96,11.7,14.98,10.93,0,0-11.01,6.94-22.24,4.65-4.84-.98-11.05-7.39-14.23-10.67,0,0-8.47,9.82-7.27,10.67s9.99,17.9,12.97,20.84c0,0-38.21-11.88-40.59-15.58-1.57-2.44-6.22-19.33-6.22-19.33,0,0-14.15,1.82-16.05,2.32-3.14.82-18.96-10.16-18.96-10.16,0,0,17.75-3.24,18.51-4.54,1.25-2.16,4.28-10.01,2.28-11.42-2-1.42-25.95-21.97-28.03-23.84s4.45-22.43,6.37-33.12c.41-2.27-.84-5.41-1.6-16.17l6.33-17.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M241.83,79.95c10.57,7.25,24.08,27.54,26.26,28.29s21.36,13.24,23.81,14.58-1.4,9.62-1.4,12.07c0,2.77,7.56,17.08,8.94,17.67s12.66,7.42,15.06,6.92c6.18-1.31,16.66-8.16,16.66-8.16,0,0-6.15,12.57-7.28,14.16-1.13,1.59-14.04,5.54-14.04,5.54,0,0,4.45,17.43,5.28,20.21s-13.53,38.34-13.53,38.34c-.33-2.64-6.86-17.75-7.63-18.99-2.57-4.11-8.77-14.19-8.77-14.19,2.22,6.18-26.06,23.42-26.06,23.42,0,0,7.34-11.73,7.34-16.13,0-2.79,1.35-5.23-3.28-7.72l11.86-17.13-4.25-45.05-28.82-14.93-.14-38.9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Colour_Normal",
    "data-name": "Colour Normal"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M241.83,239.46s-5.63,16-7.89,17.29-3.37,1.66-3.37,1.66c0,0-3.8.83-4.69-2.38l-4.95,6.65,20.78,1.69s.45-8.72,0-12.78.11-12.12.11-12.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M225.63,210.52s-2.38,5.31-1.85,11.58l-.45-2.79-10.73-18.65,13.03,9.86h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M258,394.1s-40.85-65.77-49.26-85.57c0,0,7.88,39.86,13.97,56.19s14.18,41.59,14.18,41.59l21.12-12.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M214.03,395.42s-20.89-56.19-24.35-78.23c0,0-1.49,45.55,10.15,78.23h14.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M158.45,336.1s2.16,6.72,2.64,12.9c.51,6.48-2.12,4.77-2.12,4.77,0,0-15.36-10.37-20.35-15.96,0,0,9.18,15.9,8.98,19.62s-20.41-5.32-22.94-5.65c0,0,14.36,22.14,23.34,26.13,0,0,6.38,5.24,5.59,12.8s6.38,11.54,6.38,11.54l10.57-8.13-1.49-35.18-10.61-22.83h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M288.18,395.42s34.07-66.38,38.97-86.89c4.01-16.8-3.07,63.59-16.26,89.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M357.22,328.86c6.75-27,7.98-44.8,4.6-58,0,0-4.3,27-20.25,60.76s-11.66,70.61-11.66,70.61l66.59-11.54-6.44-24.39-.92-14.08-5.52-4.95s-7.01,8.37-15.76,12.71c-2.01,1-4-1.39-2.65-3.19,5.11-6.82,12.99-18.25,13.19-24.25l3.99-8.29-8.59-15.73s5.22,9.29-.92,15.73c-3.55,3.73-9.26,9.51-13.44,13.72-1.55,1.56-4.18.14-3.72-2.02l1.51-7.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M289.7,228.91s-3.05,18.92,0,20.72c.95.56-.29-18.75,3.52-17.72,9.59,2.58,25.4,14.51,25.98,16.46.91,3.02-25.25,38.67-25.25,38.67,0,0,35.51-27.35,39.14-27.65s21.44-.15,21.44-.15l-26.26-12.68,1.12-6.49-3.69-.62-35.99-10.54h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M286.96,211.1l-.46,20.81,1.9,30.76h-21.17l7.67-39h-2.67c-5.33,12-14.67,30.78-14.67,30.78-5-5.89-8-13.77-10.33-21.78s-8.36-12.63-8.36-12.63l-22.37-18.51,16.2,4.57,29.64-5.43,6.89-7.65,12.02,6.38,5.7,11.72v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M275.04,178.82l-4.58-30.16-35.71-53.84-66.93-2.52-22.47,31.62,10.48,36.11,27.78-13.29s-8.49-16.25-7.75-23.05c0,0,20.55-3.77,25.79-1.27,2.5,1.19,5.94-16.79,14.78-19.34,17.99-5.2,17.18,8.52,17.18,8.52,0,0,5.7,22.66,8.62,25.75,1.55,1.65,5.53,6.73,9.05,11.18,3.1,3.92,5.84,7.35,6.28,7.54.29.12,1.15.67,2.24,1.43,2.42,1.71,2.66,1.67,3.12,3.41.52,1.98,6.48,18.26,7.59,23.87l4.53-5.96h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M184.68,181.39c.42-.17.9.03,1.08.44.49,1.13,1.53,3.2,2.82,3.79,1.8.81,12.45-4.87,15.88-4.92,2.22-.03,10.75,4.18,16.5,7.16.86.45.41,1.75-.54,1.58-4.85-.89-11.13-1.58-12.8.37-1.97,2.31.95,6.67,2.88,9.06.48.6-.03,1.47-.78,1.36l-27.03-3.99c-.16-.02-.31-.09-.43-.2l-9.83-8.48c-.48-.41-.35-1.19.24-1.42l12.01-4.74h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M203.51,129.01s3.73,10.56,6.19,12.67,23.86,13.03,25.47,14.42c.6.52.33,8.6,1.43,7.55,1.84-1.75,3.73-12.81,3.73-12.81,0,0-12.59-5.78-21.34-10.58-8.04-4.42-15.48-11.24-15.48-11.24h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M145.78,218.35c1.26,8.83-6.83,15.6-9,17.98s-8.01,4.74-8.01,4.74c0,0,8.58,3.66,10.49,3.43s13.93-10.87,13.93-10.87c0,0,1.44,5.46,2.07,5.91s10.16,3.51,10.16,3.51c0,0-.1-8.62-.33-10.53s-19.31-14.17-19.31-14.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M284.65,139.63s5.4-8.98,1.42-15.52c0,0-11.44-5.92-13.92-8.15s-7.81,1.58-7.81,1.58c0,0,.5,6.04,1,6.86s13.7,3.25,15.01,7.49,4.3,7.75,4.3,7.75h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M306.55,158.39s-9.41.14-11.93-3.05c0,0,10.36,12.62,14.23,13.88s14.23-4.5,14.23-4.5l6.51-11.1-6.81,5.5-16.22-.73h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M294.62,155.34s2.48,14.06-1.39,17.71c-2.92,2.76-8.58,0-8.58,0,0,0,9.68,14.3,11.76,19.95.68,1.86-2.95-28.85,12.43-23.79l-14.23-13.88h.01Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Lines_Mirror",
    "data-name": "Lines Mirror"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M275.13,208.77c-3.86,15.57-8.16,46.26-8.67,55.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M259.12,274.62s5.34-8.17,7.34-9.51,13.18,1,21.35-1.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M291.38,234.35s.23,26.64-3.57,34.68-32.55,50.97-32.55,50.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M253.77,321.91s-49.49-44.84-56.47-55.41c-2.91-4.41-5.72-9.05-8.3-12.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M329.92,246.09s45.56,22.54,48.38,22.94-14.5,47.84-18.07,53.87-19.58,28.62-20.9,46.5-.94,28.8-.94,28.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M378.15,272.92s-4.18,24.19-4.18,31.53,7.53,16.38,8.28,19.2-1.32,8.53-2.07,10.6.25,9.46,1.63,11.16,7.54,6.17,8.48,8.43.81,9.15.81,11.97,3.83,9.41,3.89,11.67,0,10.73,0,10.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M211.65,199.38c39.04,28.04,27.21,22.38,32.41,65.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M251.4,274.62s-5.34-8.17-7.34-9.51-13.18,1-21.35-1.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M220.46,259.6c.52,3.89,1.24,7.31,2.25,9.43,3.8,8.04,32.55,50.97,32.55,50.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M219.14,234.35s-.07,8.12.51,16.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M256.75,321.91s49.49-44.84,56.47-55.41,13.32-22.42,17.55-21.78c0,0,.87-2.73,0-3.85s-3.86-2.61-3.86-2.61c0,0-32.24-9.28-34.95-10.51s-4.45,1.53-4.45,1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M151.78,260.15c-9.69,4.65-18.38,8.71-19.56,8.88-2.82.4,14.5,47.84,18.07,53.87s19.58,28.62,20.9,46.5.94,28.8.94,28.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M132.37,272.92s4.18,24.19,4.18,31.53-7.53,16.38-8.28,19.2,1.32,8.53,2.07,10.6-.25,9.46-1.63,11.16-7.54,6.17-8.48,8.43-.81,9.15-.81,11.97-3.83,9.41-3.89,11.67,0,10.73,0,10.73"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 212.08,
    y1: 136.72,
    x2: 225.42,
    y2: 133.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M224.89,101.55l-14.42,6.62s-5.23,11.16-5.12,14.05,2.4,10.62,2.4,10.62c0,0-6.53-7.45-6.61-10.1s3.25-12.91,3.25-12.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M228.47,109.86s-3.91,14.62-4.79,15.7-11.11,6.67-11.11,6.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M218.39,117.23s-4.47-.16-5.06.48-1.83,4.48-1.53,5.11,2.76,2.23,3.52,2.35,4.34-2.28,4.63-2.96-.93-4.49-1.56-4.98h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M236.51,159.47s-.61-.12-1.12,1.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M238.87,169c7.29-10.45,16.16-28.75,16.16-28.75.61,12.9,8.74,24.4,7.67,29.79-1,5.02-6.12,11.55-6.12,11.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M211.9,91.82s-8.59,9.56-10.7,13.33-5.48,16.35-6.63,17.48-2.45-3.34-2.45-3.34c0,0,6.69-13.09,7.94-14.83s11.84-12.63,11.84-12.63h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M268.09,189.23s6.23-8.79,6.95-10.41c.18-.4.07-2.34-.23-5.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M263.18,195.95c4.64,2.49,3.28,4.92,3.28,7.72,0,4.4-7.34,16.13-7.34,16.13,0,0,28.28-17.24,26.06-23.42,0,0,6.2,10.08,8.77,14.19.78,1.24,7.31,16.35,7.63,18.99,0,0,14.35-35.55,13.53-38.34s-5.28-20.21-5.28-20.21c0,0,12.91-3.95,14.04-5.54s7.28-14.16,7.28-14.16c0,0-10.48,6.84-16.66,8.16-2.39.51-13.67-6.33-15.06-6.92s-8.94-14.9-8.94-17.67c0-2.45,3.85-10.73,1.4-12.07s-21.63-13.83-23.81-14.58-15.69-21.03-26.26-28.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M253.25,162.49s2.07-4.79,3.71-11.28"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 200.08,
    y1: 153.61,
    x2: 201.69,
    y2: 167.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M171.08,177.28l1.5-15.8s8.81-8.61,11.58-9.46,10.82-1.23,10.82-1.23c0,0-9.18-3.72-11.71-2.92s-11.12,7.32-11.12,7.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M180.11,177.92s12.52-8.5,13.25-9.69,2.64-12.68,2.64-12.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M183.75,165.98s-1.62-4.17-1.21-4.94,3.63-3.2,4.32-3.13,3.01,1.88,3.37,2.55-.72,4.85-1.27,5.35c-.55.5-4.54.6-5.21.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M229.6,169.2s-.32-.54,1.39-1.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M239.37,168.29c-7.47,10.32-21.83,24.71-21.83,24.71,12.38-3.67,25.92.23,30.65-2.56,4.41-2.6,8.89-9.58,8.89-9.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M157.62,168.21s6.2-11.26,9.07-14.49c2.86-3.23,13.64-10.55,14.33-12.01s-3.96-1.21-3.96-1.21c0,0-10.16,10.63-11.4,12.37s-8.04,15.33-8.04,15.33h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M268.09,189.23s-6.25,8.77-7.54,9.99-27.34,6.06-29.99,5.59-38.25-15.58-56.57-13.58c0,0-2.31-6.85-6.9-12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M207.52,196.9s6.05,26.3,6.02,31.56c-.04,7.59-2.73,13.5-1.75,16.11,2.33,6.21,14.96,11.7,14.98,10.93,0,0-11.01,6.94-22.24,4.65-4.84-.98-11.05-7.39-14.23-10.67,0,0-8.47,9.82-7.27,10.67s9.99,17.9,12.97,20.84c0,0-38.21-11.88-40.59-15.58-1.57-2.44-6.22-19.33-6.22-19.33,0,0-14.15,1.82-16.05,2.32-3.14.82-18.96-10.16-18.96-10.16,0,0,17.75-3.24,18.51-4.54,1.25-2.16,4.28-10.01,2.28-11.42-2-1.42-25.95-21.97-28.03-23.84s4.45-22.43,6.37-33.12c.41-2.27-.84-5.41-1.6-16.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M237.96,184.01s-3.84,3.53-9.43,7.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M209.23,199.38s14.55,20.22,14.55,23.55-1.85,29.1-1.85,29.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M215.03,230.5s4.87-1.84,5.93-1.41,2.37,2.47,2.37,2.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M284.65,200.66s2.31,8.36,2.31,10.44-.42,36.26,2.24,46.06"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Hair_Top_Colour",
    "data-name": "Hair Top Colour"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M128.77,171.62s10.24,5.32,18.7,14.94c8.46,9.62,10.15,18.06,10.15,18.06l27.49,7.68s1.94,10.91.7,24.64c0,0,8.85,7.33,14.43,7.57s4.51-5.44,4.51-5.44l-8.91-.37s1.54,1.04-4.99-3.6,3.78-26.96,3.78-26.96l-24.15-10.81-6.01-18.15-1.86-13.69,8.16,2.17-14.15-13.72-.9-17.71,5.99,7.13,21.96,8.59-15.14-12.33-6.53-21.12,7.93-1.97-6.96-8.87s11.1.42,21.97,4.03c10.87,3.61,17.11,6.93,17.11,6.93l-13.2-11.38-10.38-5.04,22.53-.94,14.88,5.35-10.17-8.9,25.93,4.76,4.41,6.37,5.88,23.03,29.4,10.23s1.8,22.24,2.61,23.2c.81.96-12.42,6.99-12.42,6.99l14.68-.69s5.28-26.36-6.99-38.25c0,0-13.87-6.39-19.83-10.62-2.75-1.95-.77-27.75-7.81-40.51-5.23-9.47-11.61-22.01-11.61-22.01,0,0-14.4,7.34-22.48,4.78s-24.39-10.61-24.39-10.61l-20.96,9,11.9-16.75,15.89-.29-21.54-5.04s-19.09,23.59-24.32,24.91-19.11,7.71-19.11,7.71l11.5,13.77-31.99,9.01s4.34,25.68.38,31.26c-3.97,5.58-20.83,20.12-33.99,21.03s31.54,3.18,34.89,1.08,13.86-27.92,10.46-33.11-.39-17.06-.39-17.06l19.66-4.28-13.32,14.81-3.37,31.54c.36,12.59,2.51,26.88-5.62,31.49l6.48,20.44,17.88,12.42-13.21-25.43,4.44-9.32.02.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M126.83,173.81s-2.97-24.04-5.49-28.65,1.07-21.35,1.07-21.35c0,0,2.2,1.97,4.57.4s9.8-18.64,11.72-20.9c0,0,1.22,17.24,3.98,21.73s5.34,16.96,5.34,16.96c0,0-7.4-7.44-8.93-7.27s24.02,46.2,24.02,46.2l-16.55-12.39s-4.15-11.58-7.97-14.36c0,0-11.48,7.12-11.75,19.62h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M91.78,145.02s18.58-3.05,21.15-13.35c2.56-10.3-.85-15.21-.85-15.21,0,0-2.82,21.01-20.29,28.56h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M164.67,140.67s-10.03-15.25-12.13-18.12-3.03-15.59-3.03-15.59l8.4,12.35s6.76,21.36,6.76,21.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M165.23,95.95l-7.12-3.04s14.55-5.62,15.62-12.83-16.45-11.69-16.45-11.69c0,0,10.48-5.9,14.51-5.95s9.47-1.24,12.02.57,9.62,4.38,14.13,4.52c0,0,18.39,12.76,23.17,15.54,0,0-18.2-6.34-27.8-3.19,0,0-6.14,6.91-17.5,6.7,0,0,10.33,6.61,9.34,9.74s-7.74,5.5-19.91-.37h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M124.5,72.99s15.5,1.45,17.92-.12,7.65-5.28,6.93-11.69c0,0-3.75,3.77-5.26,4.6s-19.59,7.21-19.59,7.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M237.25,113.49s9.17-6.24,9.05-15.92c0,0-.39,21.95,4.92,25.8,5.31,3.85,15.79,7.79,16.1,11.02s-12.83,6.69-25.37-2.49c0,0-2.89-13.67-4.7-18.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M185.86,218.75s2.78,10.6,7.04-2.75c0,0-2.17,7.69-2.32,12.77s2.54,9.66.18,11.51-5.92-2.4-5.92-2.4l1.02-19.13h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "263.99 171.16 272.15 165.59 276.23 170.56 263.99 171.16"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Lines_Normal",
    "data-name": "Lines Normal"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M252.15,320s13.67,15,14.05,17.93-1.91,15.41-1.91,23.43,3.31,32.73,3.31,32.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M149.2,122.91c4.21,4.78,8.94,19.32,12.5,21.86,3.57,2.53,25.97,10.25,25.97,10.25-6.06-3.86-14.23-13.54-15.84-15.27s-8.72-19.63-7.7-20.84,9.44-.9,9.44-.9c0,0-8.96-8.16-8.29-9.32s29.06,7.38,34.36,10.4,12.16,8.04,12.16,8.04c0,0-18.1-17.94-19.89-19.2s-27.26-11.17-27.26-11.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M137.55,134.9s16.95,25.85,21.61,28.13,21.02,8.58,21.02,8.58c0,0-18.59-13.06-20.95-17.71s-3.72-19.74-3.72-19.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M183.08,103.15s16.02-2.19,22.92.48c6.9,2.67,17.6,8.18,17.6,8.18,0,0-17.16-14.88-19.74-16.71s-20.98-6.56-25.84-10.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M163.41,61.72c1.95-1.32,11.34-14.3,11.34-14.3,7.23,1.75,30.67-.9,30.67-.9-8.36,1.34-37.02-6.83-37.02-6.83-3.71,7.36-19.4,19.92-22.64,23.04s-22.7,9.78-22.7,9.78c1.25,4.44,11.19,15.24,11.19,15.24,0,0-27.44,5.39-31.38,8.05,0,0,6.17,19.92-1.65,34.53-7.81,14.6-40.33,19.5-40.33,19.5,0,0,34.68,5.51,44.51,2.25s13.02-28.42,12.47-31.49-2.94-14.85-.68-18.03,16.6-5.28,16.6-5.28c0,0-11.05,8.31-13.03,11.09s-4.37,25.68-3.1,41.03c1.32,15.92-4.48,24.1-4.48,24.1,0,0,4.87,17.72,6.01,22.12,0,0,15.73,10.16,23.41,13.06,0,0-17.89-22.4-16.75-28.09,1.14-5.68,14.97-26.21,11.24-34.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M163.82,165.32s4.56,28.62,8.43,32.02c5.57,4.89,19.32,6.45,21.9,8.29s-5.79,24.4-1.57,29.31c1.99,2.31,3.77,4.14,7.73,3.31,3.96-.82,5.1-7.62,5.1-7.62,0,0,0,12.88-3.32,14.82-4.35,2.53-15.47-5.47-18.48-7.09,0,0,4.59-21.93-1.49-24.7s-23.3-5.93-25.77-7.95-8.06-25.18-27.59-32.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M209.76,98.94s14.29,1.97,20.45,6.09c6.16,4.12,8.24,27.29,10.83,29.13s19.26,5.57,25.17,8.22,4.87,17.31,5.39,21.32c.53,4.01-13.78,7.91-13.78,7.91,0,0,14.55,3.23,18.4,0,3.86-3.23.08-35.14-2.44-37.45,0,0-17.04-6.98-21.65-11.81s-6.61-35.84-6.61-35.84l-16.02-28.46s-7.07,6.16-16.42,5.27-28.79-10.97-29.91-10.58-33.31,14.94-35.11,17.23-7.06,12.09-7.06,12.09"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMrskexcited);
export default __webpack_public_path__ + "static/media/mrsk excited.c715ae5735fbb06b4f22a7e5c5bb30cf.svg";
export { ForwardRef as ReactComponent };